import { Admin, Resource } from "react-admin";
import { ArtistList, ArtistShow } from "./resources/artists";
import { BitrateProfileCreate, BitrateProfileEdit, BitrateProfileList, BitrateProfileShow } from "./resources/bitrate-profiles";
import { ChannelCreate, ChannelEdit, ChannelList, ChannelShow } from "./resources/channels/channels";
import { ChannelLinkToVerticalModeCreate, ChannelLinkToVerticalModeEdit, ChannelLinkToVerticalModeList, ChannelLinkToVerticalModeShow } from "./resources/channels/channels-link-to-vertical-mode";
import { ChannelOrderingList } from "./resources/channels/channels-ordering";
import { CodingProfileCreate, CodingProfileEdit, CodingProfileList, CodingProfileShow } from "./resources/coding-profiles";
import { DrmProfileCreate, DrmProfileEdit, DrmProfileList, DrmProfileShow } from "./resources/drm-profiles";
import { EpisodeOrderingList } from "./resources/episode-ordering";
import { EpisodeEdit, EpisodeList, EpisodeShow } from "./resources/episodes";
import { MenuTreeCreate } from "./resources/menu-tree/menu-tree-create";
import { MenuTreeEdit } from "./resources/menu-tree/menu-tree-edit";
import { MenuTreeList } from "./resources/menu-tree/menu-tree-list";
import { GeneralMenuTreePreview, KidsMenuTreePreview } from "./resources/menu-tree/menu-tree-preview";
import { ProgrammeEdit, ProgrammeList, ProgrammeShow } from "./resources/programmes";
import { RoleCreate, RoleEdit, RoleList, RoleShow } from "./resources/roles/roles";
import { UserCreate, UserEdit, UserList, UserShow } from "./resources/users/users";

// import { FilteringList, FilteringShow, FilteringEdit } from "./resources/subcat-filters/subcat-filters";
import { AdGroupingCreate, AdGroupingEdit, AdGroupingList } from "./resources/ad-groupings";
import { EditorialCreate, EditorialEdit, EditorialList, EditorialShow } from "./resources/editorial";
import { EventTypeEdit, EventTypeList } from "./resources/event-type";
import { EventCreate, EventEdit, EventList, EventShow } from "./resources/events";
import { HorseRaceCreate, HorseRaceEdit, HorseRaceList } from "./resources/horserace";
import { HorseRaceDataCreate, HorseRaceDataEdit, HorseRaceDataList } from "./resources/horserace-data";
import { GeneralHotSearchCreate, GeneralHotSearchEdit, GeneralHotSearchList, GeneralHotSearchShow, KidsHotSearchCreate, KidsHotSearchEdit, KidsHotSearchList, KidsHotSearchShow } from "./resources/hot-searches/hot-searches";
import { ImagesList } from "./resources/images";
import { KeyValueCreate, KeyValueEdit, KeyValueList, KeyValueShow } from "./resources/key-values";
import { LandingList } from "./resources/landing";
import { MPMList } from "./resources/mpm";
import { NotyCreate, NotyEdit, NotyList, NotyShow } from "./resources/notification/notification";
import { PosterCreate, PosterEdit, PosterList, PosterShow } from "./resources/overide-poster";
import { PasswordCreate } from "./resources/password";
import { GeneralProfileIconCreate, GeneralProfileIconEdit, GeneralProfileIconList, GeneralProfileIconShow, KidsProfileIconCreate, KidsProfileIconEdit, KidsProfileIconList, KidsProfileIconShow } from "./resources/profile-icons";
import { GeneralProfilesPreferenceCreate, GeneralProfilesPreferenceList, KidsProfilesPreferenceCreate, KidsProfilesPreferenceList } from "./resources/profiles-preferences";
import { SlotCreate, SlotEdit, SlotList } from "./resources/slots";
import { FilteringEdit } from "./resources/subcat-filters/subcat-filters-edit";
import { FilteringList } from "./resources/subcat-filters/subcat-filters-list";
import { TagsList, TagsShow } from "./resources/tags";
import { TrafficLogEdit, TrafficLogList } from "./resources/traffic-logs";
import { VipCreate, VipEdit, VipShow, VipsList } from "./resources/vips";

import { IMCannedMessageCreate, IMCannedMessageEdit, IMCannedMessageList } from "./resources/im-canned-messages/im-canned-messages";
import { IMChatroomCreate, IMChatroomEdit, IMChatroomList, IMChatroomShow } from "./resources/im-chatrooms/im-chatrooms";
import { IMIconCreate, IMIconEdit, IMIconList } from "./resources/im-icons/im-icons";
import { IMPaidIconPackCreate, IMPaidIconPackEdit, IMPaidIconPackList, IMPaidIconPackShow } from "./resources/im-paid-icons/im-paid-icon-packs";

import { MpmRowCreate, MpmRowEdit } from "./resources/mpm-rows/mpm-rows";
import { MpmRowByPlatformEdit } from "./resources/mpm-rows-by-platform/mpm-rows-by-platform";
import { GeneralHomepageEdit, GeneralHomepageList, GeneralPageEdit, KidsHomepageEdit, KidsHomepageList, PageCreate, PageList } from "./resources/pages/pages";

import { CategoriesEdit, CategoriesList, CategoriesShow } from "./resources/categories";
import { ChannelNoList } from "./resources/channel-nos";
import { SpecialProgramList } from "./resources/special-programs";
import { CanvasAdList } from "./resources/canvas-ad";
import { VipoBlacklistList } from "./resources/vipo-blacklist";

import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import PeopleIcon from "@material-ui/icons/People";
import TvIcon from "@material-ui/icons/Tv";
import authProvider from "./authProvider";
import { customRoutes } from "./customRoutes";
import dataProvider from "./dataProvider";
import { MyLayout } from "./MyLayout";

import { ImportRequestsList } from "./resources/import-requests/import-requests";

import { EmarsysTitleHomepageList, EmarsysTitlePageEdit } from "./resources/emarsys-title/emarsys-title";

import { EpisodePreviewScheduleList } from "./resources/episode-preview-schedules/episode-preview-schedules-list";
import { McdnAppNameEdit, McdnAppNameList } from "./resources/mcdn-appname";
import { OverwritePosterModuleCreate } from "./resources/overwrite-poster-module/create";
import { OverwritePosterModuleList } from "./resources/overwrite-poster-module/list";
import { PageRowPathEdit } from "./resources/page-row-paths/page-row-paths-edit";
import { PageRowPathList } from "./resources/page-row-paths/page-row-paths-list";
import { FilteringOverwriteCreate } from "./resources/subcat-filter-overwrite/subcat-filter-overwrite-create";
import { FilteringOverwriteEdit } from "./resources/subcat-filter-overwrite/subcat-filter-overwrite-edit";
import { FilteringOverwriteList } from "./resources/subcat-filter-overwrite/subcat-filter-overwrite-list";
import { VipsAdFreeCreate, VipsAdFreeEdit, VipsAdFreeList, VipsAdFreeShow } from "./resources/vips-ad-free";

import { VodLivesList } from "./resources/vod-lives/vod-lives-list";
import { VodLivesEdit } from "./resources/vod-lives/vod-lives-edit";
import { VodLivesShow } from "./resources/vod-lives/vod-lives-show";

import { ChannelCategoryList, ChannelCategoryCreate, ChannelCategoryEdit } from "./resources/channel-categories";
import { ChannelCategoryOrderingList } from "./resources/channel-category-ordering";
import { BottomMenuCreate, BottomMenuEdit, BottomMenuList } from "./resources/bottom-menu/bottom-menu";
import { EpgListingList, EpgListingCreate } from "./resources/epg-listing/epg-listing";
import { EpgEditListingEdit, EpgEditListingList } from "./resources/epg-listing/epg-edit-listing";
import { LiveToContentList, LiveToContentCreate, LiveToContentEdit } from "./resources/live-to-content/live-to-content";
import { EpgModificationList, EpgModificationCreate, EpgModificationEdit } from "./resources/epg-modification/epg-modification";
import { AdsVideoCreate, AdsVideoEdit, AdsVideoList, AdsVideoShow } from "./resources/ads-video";

const App = () => (
  <Admin
    // theme={Customtheme}
    authProvider={authProvider}
    dataProvider={dataProvider}
    customRoutes={customRoutes}
    layout={MyLayout}
    disableTelemetry

    // dashboard={Dashboard}
  >
    <Resource name="landing" list={LandingList} />

    <Resource name="ads" icon={NarrowIcon} options={{ label: "Ads", isMenuParent: true }} />
    <Resource name="ads-adgroups" list={AdGroupingList} create={AdGroupingCreate} edit={AdGroupingEdit} options={{ label: "Ad Grouping", menuParent: "ads" }} />
    <Resource name="ads-video" list={AdsVideoList} create={AdsVideoCreate} edit={AdsVideoEdit} show={AdsVideoShow} options={{ label: "Ads Video", menuParent: "ads" }} />

    <Resource name="admin" icon={NarrowIcon} options={{ label: "Admin", isMenuParent: true }} />
    <Resource name="roles" list={RoleList} show={RoleShow} edit={RoleEdit} create={RoleCreate} options={{ label: "Roles", menuParent: "admin" }} />
    <Resource name="users" list={UserList} show={UserShow} edit={UserEdit} create={UserCreate} icon={PeopleIcon} options={{ label: "Users", menuParent: "admin" }} />

    <Resource name="mpm-group" icon={NarrowIcon} options={{ label: "Editorial Pick", isMenuParent: true }} />
    <Resource options={{ label: "Editorial Listing", menuParent: "mpm-group" }} name="editorial-types" list={EditorialList} edit={EditorialEdit} create={EditorialCreate} show={EditorialShow} />

    <Resource name="epg" icon={NarrowIcon} options={{ label: "EPG", isMenuParent: true }} />
    <Resource options={{ label: "EPG Edit List", menuParent: "epg" }} name="epg-edit-listing" list={EpgEditListingList} edit={EpgEditListingEdit} />
    <Resource options={{ label: "EPG Modification (Bonus VOD)", menuParent: "epg" }} name="epg-modification" list={EpgModificationList} create={EpgModificationCreate} edit={EpgModificationEdit} />
    <Resource options={{ label: "Live to Content List", menuParent: "epg" }} name="live-to-content-schedules" list={LiveToContentList} create={LiveToContentCreate} edit={LiveToContentEdit} />

    <Resource name="events" list={EventList} edit={EventEdit} create={EventCreate} show={EventShow} />

    <Resource name="frontend-ui" icon={NarrowIcon} options={{ label: "Frontend UI", isMenuParent: true }} />
    <Resource name="emarsys-title" options={{ label: "Emarsys Title", menuParent: "frontend-ui" }} list={EmarsysTitleHomepageList} edit={EmarsysTitlePageEdit} />
    <Resource name="mpm-home-page" options={{ label: "Homepage", menuParent: "frontend-ui" }} list={GeneralHomepageList} edit={GeneralHomepageEdit} />
    <Resource name="menu-tree/preview" options={{ label: "Menu Tree", menuParent: "frontend-ui" }} list={GeneralMenuTreePreview} />
    <Resource name="mpm-pages" options={{ label: "Page", menuParent: "frontend-ui" }} list={PageList} create={PageCreate} edit={GeneralPageEdit} />
    <Resource name="page-row-paths" options={{ label: "Page / Row Path", menuParent: "frontend-ui" }} list={PageRowPathList} edit={PageRowPathEdit} />

    <Resource name="horserace" list={HorseRaceList} edit={HorseRaceEdit} create={HorseRaceCreate} />

    <Resource name="hot-searchs" options={{ label: "Hot Searches" }} list={GeneralHotSearchList} show={GeneralHotSearchShow} edit={GeneralHotSearchEdit} create={GeneralHotSearchCreate} />

    <Resource name="im" icon={NarrowIcon} options={{ label: "Instant Message", isMenuParent: true }} />
    <Resource name="im-canned-messages" options={{ label: "Canned Message", menuParent: "im" }} list={IMCannedMessageList} edit={IMCannedMessageEdit} create={IMCannedMessageCreate} />
    <Resource name="im-rooms" options={{ label: "Chat Room", menuParent: "im" }} list={IMChatroomList} edit={IMChatroomEdit} create={IMChatroomCreate} show={IMChatroomShow} />
    <Resource name="im-icons" options={{ label: "Free Icon", menuParent: "im" }} list={IMIconList} edit={IMIconEdit} create={IMIconCreate} />
    <Resource name="im-paid-icon-packs" options={{ label: "Paid Icon", menuParent: "im" }} list={IMPaidIconPackList} edit={IMPaidIconPackEdit} create={IMPaidIconPackCreate} show={IMPaidIconPackShow} />

    <Resource name="kids" icon={NarrowIcon} options={{ label: "Kids mode", isMenuParent: true }} />
    <Resource name="kids-mpm-home-page" options={{ label: "Homepage", menuParent: "kids" }} list={KidsHomepageList} edit={KidsHomepageEdit} />
    <Resource name="kids-hot-searchs" options={{ label: "Hot Searches", menuParent: "kids" }} list={KidsHotSearchList} show={KidsHotSearchShow} edit={KidsHotSearchEdit} create={KidsHotSearchCreate} />
    <Resource name="kids-menu-tree/preview" options={{ label: "Menu Tree", menuParent: "kids" }} list={KidsMenuTreePreview} />
    <Resource name="kids-profile-icons" options={{ label: "Profile Icons", menuParent: "kids" }} list={KidsProfileIconList} edit={KidsProfileIconEdit} create={KidsProfileIconCreate} show={KidsProfileIconShow} />
    <Resource name="kids-profiles-preferences" options={{ label: "Profiles Preference", menuParent: "kids" }} list={KidsProfilesPreferenceList} create={KidsProfilesPreferenceCreate} />

    <Resource name="master-table" icon={NarrowIcon} options={{ label: "Master Table", isMenuParent: true }} />
    <Resource name="artists" options={{ label: "Artists", menuParent: "master-table" }} list={ArtistList} show={ArtistShow} />
    <Resource name="event-type" options={{ label: "Event Type", menuParent: "master-table" }} list={EventTypeList} edit={EventTypeEdit} />
    <Resource name="mcdn-appname" options={{ label: "MCDN Appname", menuParent: "master-table" }} list={McdnAppNameList} edit={McdnAppNameEdit} />
    <Resource name="profile-icons" list={GeneralProfileIconList} edit={GeneralProfileIconEdit} create={GeneralProfileIconCreate} show={GeneralProfileIconShow} options={{ label: "Profile Icons", menuParent: "master-table" }} />
    <Resource name="tags" list={TagsList} show={TagsShow} options={{ label: "Tags", menuParent: "master-table" }} />

    <Resource name="pools" icon={NarrowIcon} options={{ label: "Pools", isMenuParent: true }} />
    <Resource name="channel-nos" list={ChannelNoList} icon={TvIcon} options={{ label: "Channels", menuParent: "pools" }} />
    <Resource name="channel-categories" list={ChannelCategoryList} create={ChannelCategoryCreate} edit={ChannelCategoryEdit} options={{ label: "Channels Category", menuParent: "pools" }} />
    <Resource name="channel-categories-ordering" list={ChannelCategoryOrderingList} options={{ label: "Channels Category Ordering", menuParent: "pools" }} />
    <Resource name="channel-ordering" list={ChannelOrderingList} options={{ label: "Channels Ordering", menuParent: "pools" }} />
    <Resource name="channel-link-to-vertical-mode" list={ChannelLinkToVerticalModeList} create={ChannelLinkToVerticalModeCreate} edit={ChannelLinkToVerticalModeEdit} show={ChannelLinkToVerticalModeShow} options={{ label: "Channels Link To Vertical Mode", menuParent: "pools" }} />
    <Resource name="subcat-filters" list={FilteringList} edit={FilteringEdit} options={{ label: "Filtering", menuParent: "pools" }} />
    <Resource name="images" list={ImagesList} options={{ label: "Image", menuParent: "pools" }} />
    <Resource name="programme-overwrite-poster-module" list={OverwritePosterModuleList} create={OverwritePosterModuleCreate} options={{ label: "Overwrite Programme Poster", menuParent: "pools" }} />
    <Resource name="programmes" list={ProgrammeList} show={ProgrammeShow} edit={ProgrammeEdit} options={{ label: "Programmes", menuParent: "pools" }} />

    <Resource name="episode-preview-schedules" list={EpisodePreviewScheduleList} options={{ label: "Preview Schedule" }} />

    <Resource name="profiles" icon={NarrowIcon} options={{ label: "Profiles", isMenuParent: true }} />
    <Resource name="bitrate-profiles" list={BitrateProfileList} show={BitrateProfileShow} edit={BitrateProfileEdit} create={BitrateProfileCreate} options={{ label: "Bitrate Profile", menuParent: "profiles" }} />
    <Resource name="coding-profiles" list={CodingProfileList} show={CodingProfileShow} edit={CodingProfileEdit} create={CodingProfileCreate} options={{ label: "Coding Profile", menuParent: "profiles" }} />
    <Resource name="drm-profiles" list={DrmProfileList} show={DrmProfileShow} edit={DrmProfileEdit} create={DrmProfileCreate} options={{ label: "DRM Profile", menuParent: "profiles" }} />

    <Resource name="profiles-preferences" options={{ label: "Profiles Preference" }} list={GeneralProfilesPreferenceList} create={GeneralProfilesPreferenceCreate} />

    <Resource name="AD Operation" icon={NarrowIcon} options={{ label: "AD Operation", isMenuParent: true }} />
    <Resource name="special-program" list={SpecialProgramList} options={{ label: "Special Program", menuParent: "AD Operation" }} />
    <Resource name="canvas-ad" list={CanvasAdList} options={{ label: "Canvas AD", menuParent: "AD Operation" }} />

    <Resource name="push-notifications" options={{ label: "Push Notifications" }} list={NotyList} edit={NotyEdit} create={NotyCreate} show={NotyShow} />

    <Resource name="vipo-blacklist" list={VipoBlacklistList} edit={VipEdit} create={VipCreate} show={VipShow} options={{ label: "VIPO Blacklist" }} />

    <Resource name="traffic-log" list={TrafficLogList} edit={TrafficLogEdit} options={{ label: "Traffic Log" }} />

    <Resource name="vips" list={VipsList} edit={VipEdit} create={VipCreate} show={VipShow} />

    <Resource name="vips-ad-free" list={VipsAdFreeList} edit={VipsAdFreeEdit} create={VipsAdFreeCreate} show={VipsAdFreeShow} />

    <Resource name="episode-ordering" list={EpisodeOrderingList} />

    {/* this is only for QA */}
    <Resource name="vod-live-testing-data" list={VodLivesList} show={VodLivesShow} edit={VodLivesEdit} options={{ label: "VOD live testing data" }} />

    <Resource name="bottom-menu" list={BottomMenuList} edit={BottomMenuEdit} create={BottomMenuCreate} options={{ label: "Bottom Menu" }} />

    {/* Pages not shown in Menu */}
    <Resource name="key-values" list={KeyValueList} edit={KeyValueEdit} create={KeyValueCreate} show={KeyValueShow} />
    <Resource name="categories" list={CategoriesList} edit={CategoriesEdit} show={CategoriesShow} options={{ label: "Categories", menuParent: "hide" }} />
    <Resource name="import-requests" list={ImportRequestsList} edit={ImportRequestsList} options={{ label: "", menuParent: "hide" }} />
    <Resource name="slots" list={SlotList} edit={SlotEdit} create={SlotCreate} />
    <Resource name="episodes" list={EpisodeList} show={EpisodeShow} edit={EpisodeEdit} />
    <Resource name="password" create={PasswordCreate} />
    <Resource name="channels" list={ChannelList} show={ChannelShow} edit={ChannelEdit} create={ChannelCreate} icon={TvIcon} options={{ label: "Channels", menuParent: "pools" }} />
    <Resource name="subcat-filter-overwrite-list" list={null} edit={FilteringOverwriteList} />
    <Resource name="subcat-filter-overwrite-create" list={null} edit={FilteringOverwriteCreate} />
    <Resource name="subcat-filter-overwrite-edit" list={null} edit={FilteringOverwriteEdit} />
    <Resource name="programme-overwrite-posters" list={PosterList} show={PosterShow} edit={PosterEdit} create={PosterCreate} />
    <Resource name="horserace-data" list={HorseRaceDataList} edit={HorseRaceDataEdit} create={HorseRaceDataCreate} />
    <Resource name="mpm-rows" create={MpmRowCreate} edit={MpmRowEdit} />
    <Resource name="mpm-rows-by-platform" edit={MpmRowByPlatformEdit} />
    <Resource name="menu-tree" list={MenuTreeList} create={MenuTreeCreate} edit={MenuTreeEdit} options={{ label: "Menu Tree", menuParent: "hide" }} />
    <Resource name="mpm" list={MPMList} options={{ label: "myTV SUPER", menuParent: "mpm-group" }} />
    <Resource name="epg-listing" list={EpgListingList} create={EpgListingCreate} />

    {/* API only */}
    <Resource name="mpm-row-templates" />
    <Resource name="programmes-autocomplete" />
    <Resource name="im-canned-messages-autocomplete" />
    <Resource name="episodes-autocomplete" />
    <Resource name="editorials-autocomplete" />
    <Resource name="clips-autocomplete" />
    <Resource name="channels-autocomplete" />
    <Resource name="channels-autocomplete-2" />
    <Resource name="channels-autocomplete-by-network-code" />
    <Resource name="mpm-page-autocomplete" />
    <Resource name="progammes-by-prorgamme_id" />
    <Resource name="clip-by-clip_id" />
    <Resource name="channels-by-network_code" />
    <Resource name="key-value-by-quality" />
    <Resource name="key-value-by-image-type" />
    <Resource name="key-value-by-image-platform" />
    <Resource name="key-value-by-platform" />
    <Resource name="key-value-by-drm" />
    <Resource name="key-value-by-coding" />
    <Resource name="key-value-by-event" />
    <Resource name="clips-type" />
    <Resource name="tags-autocomplete-by-id" />
    <Resource name="tags-autocomplete-by-tag-id" />
    <Resource name="tags-checkbox" />
    <Resource name="tags-programme-show" />
    <Resource name="vod-lives" />
    <Resource name="mpm-row-schedules/type" />
    <Resource name="vodlives-autocomplete" />
    <Resource name="tags/type" />
    <Resource name="tags-for-show" />
    <Resource name="profiles-mapping" />
    <Resource name="mpm-row-page" />
    <Resource name="mpm-row-tag-autocomplete" />
    <Resource name="ads-adgroups-programs-search" />
    <Resource name="ads-adgroups-programs" />
    <Resource name="ads-video-categories" />
    <Resource name="special-program-programs" />
    <Resource name="canvas-ad-programs" />
    <Resource name="programmes-for-import-requests" />
    <Resource name="permissions" />
    <Resource name="channel-categories-order-platforms" />
  </Admin>
);

export default App;

const NarrowIcon = () => {
  return <ArrowForwardIosIcon fontSize="small" />;
};
